import React from 'react';
import { connect } from 'react-redux';

import {AdSlot} from 'react-dfp';



// const Twitter = () => (
//
//   <a class="twitter-timeline" href="https://twitter.com/TwitterDev/timelines/539487832448843776?ref_src=twsrc%5Etfw">National Park Tweets - Curated tweets by TwitterDev</a>
// );


class SidebarWidgets extends React.Component {

  loadSecondaryAd() {
    return (<AdSlot sizes={[[160, 600]]}
                            dfpNetworkId='15308329'
                            adUnit='Results'
      />);
    // ,
    //   document.querySelectorAll(".ad-container-2")[0]);
  }

  render() {

    if (this.props.ads && this.props.ads.showFull && this.props.ads.type === 'adsense') {
      return (
      <div className="sidebar">
        <ul className="widgets">
          <li className="widget widget-ad">
            <AdSlot sizes={[[160,600]]}
                    dfpNetworkId='15308329'
                    adUnit='Results'
                    // targetingArguments={ {'customKw': 'test'} }
                    // sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90], [300, 250]]},
                    //   {viewport: [900, 768], sizes:[[300, 250]] }] }
                    // onSlotRender={this.loadSecondaryAd}
              /* never refresh this adSlot */
                    shouldRefresh={ ()=> true }
            />
          </li>
        </ul>
      </div>
      );
    }

    return null;

    // return (
    //   <div className="sidebar">
    //     <ul className="widgets">
    //       {/*<li className="widget widget-tweets">*/}
    //         {/*<div className="widget-head">*/}
    //           {/*<h3 className="widget-title">Twitter Feed</h3>*/}
    //         {/*</div>*/}
    //
    //         {/*<Twitter />*/}
    //       {/*</li>*/}
    //
    //       {/*<li className="widget widget-ad">*/}
    //         {/*<img src="/styles/images/temp/ad.jpg" alt="" />*/}
    //       {/*</li>*/}
    //     </ul>
    //   </div>
    // );
  }
}


function mapStateToProps(state) {
  return {
    isMobile: state.rr360.isMobile,
    ads: state.rr360.ads
  };
}


export default connect(mapStateToProps, undefined)(SidebarWidgets);



// WEBPACK FOOTER //
// ./src/components/SidebarWidgets.js